import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M12 3v18","key":"svg-1"}]]

const IconCircleHalf = createReactComponent('outline', 'circle-half', 'CircleHalf', __iconNode);

export default IconCircleHalf;